import { defineStore } from "pinia";

export interface IChatRoomConfig {
  id: number;
  user_name: string;
  date: string;
  mode: string;
}

export const useChatRoomConfigStore = defineStore("chatRoomConfig", {
  state: (): { config: IChatRoomConfig | null } => ({ config: null }),
  persist: true,
  actions: {
    save(config: IChatRoomConfig) {
      this.config = config;
    },
    clear() {
      this.config = null;
    },
  },
});
